import { Flags } from "@/providers/LaunchDarklyProvider";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useOnboardingRecord } from "./status";
import type { Stage } from "./types";

/** The LaunchDarkly boolean is onboarding's only switch. */
export function useOnboardingEnabled(): boolean {
  return !!useFlags<Flags>().onboarding;
}

/** `off` when the flag is off, otherwise where the record says this user is. */
export function useOnboardingStage(): Stage {
  const enabled = useOnboardingEnabled();
  const { stage } = useOnboardingRecord();
  return enabled ? stage : "off";
}
